import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { isDate } from 'moment';
import { forkJoin } from 'rxjs';
import { CalService } from 'src/app/auth/cal.service';
import { UserList, FacilityAcd, Priority, Facility, AttachmentDetails, FormDataModel } from 'src/app/interfaces/dashboard';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { commonService } from 'src/app/services/common.service';
import { AcdService } from 'src/app/services/dashboard.service';
import { getAcdEnvConfig } from 'src/app/configs/acd-env.config';
@Component({
  selector: 'app-acd-form',
  standalone: false,
  templateUrl: './acd-form.component.html',
  styleUrl: './acd-form.component.scss'
})
export class AcdFormComponent1 {
  httpOptions: any = '';
  token = '';
  isFormClicked: boolean = false;
  userName: string | null = '';
  public userList: UserList[] = [];
  public facilityList: Array<FacilityAcd> = [];
  public facilityListDD: Array<{ id: number, label: string }> = [];
  public priorityListDD: Array<{ id: number, label: string }> = [];
  public priorityList: Array<Priority> = [];
  public selectedFacilityItem: Array<Facility> = [];
  public selectedPriorityItem: Array<Priority> = [];
  selectedFacilityId: number = 0;
  selectedPriorityId: number = 0;
  showPriorityValue = true;
  fafile = this.iconPack.FaFileDelete;
  faclose = this.iconPack.Faclose;
  loginUserId: number = sessionStorage.getItem('userId') as unknown as number;
  AssignUserId: number = this.loginUserId;
  AcdForm!: FormGroup;
  selectedUser: string = "";
  isUserCanAccessRequest = false;
  showSubmitDate = false;
  isUserHasAdminRole = false;
  placeholderValue: string = "Select item"
  public format: FormatSettings = {
    displayFormat: "dd/MM/yyyy",
    inputFormat: "dd/MM/yyyy",
  };
  uploadedfiles: any[] = [];
  defaultOption = "Select Option"
  fileAttachmentDetails = new Array<AttachmentDetails>();
  acdEnv = getAcdEnvConfig();
  statusType = this.acdEnv.status;
  @Output() fileUploaded = new EventEmitter<AttachmentDetails>();
  acceptedFileTypes: string[] = this.commonservice.commonAcceptedFiles;

  crNo: number = 0;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private acdservice: AcdService,
    public commonservice: commonService,
    private attachmentservice: AttachmentService,
    private iconPack: EmdmIcons
  ) {

  }

  ngOnInit() {
    this.intializeAcdFormData();
    let isSpecialist = sessionStorage.getItem('specialist');
    let isAdmin = sessionStorage.getItem('admin');
    this.isUserHasAdminRole = (isSpecialist || isAdmin) == 'true' ? true : false;
    this.userName = sessionStorage.getItem('userName');
    const value = this.route.snapshot.queryParamMap.get('CR');
    this.crNo = parseInt(value ?? "0");
    // this.getPrioirtyList();
    // this.getUser_FacilityList();
    if (this.crNo == 0) {
      this.newRequestData();
    } else {
      this.defineRequestData();
    }
  }

  newRequestData() {
    this.acdservice.getAllInfo().subscribe((data) => {
      if (data) {
        this.setDropDownData(data);
        this.isUserCanAccessRequest = true;
      }
    });
  }

  defineRequestData() {
    this.acdservice.getDefineInfo(this.crNo).subscribe((data) => {
      if (data) {
        this.setDropDownData(data);
        this.crDetails = JSON.parse(JSON.stringify(data));
        this.isUserCanAccessRequest = this.isUserHasAdminRole || data.isUserCanAccessRequest || (data?.IsUserCanAccessRequest ?? false);
        data.status = data.status.label;
        data.facility = data.facility.label;
        data.priority = data.requestPriority.label;
        data.onBehalfOf = data.onBehalfOf.name;
        data.createdDate = data.createdDateTime;
        data.mocDueDate = data.mocDateTime;
        data.closedDate = data.closedDateTime;
        data.dueDate = data.dueDateTime;
        data.ferrMoc = data.ferrmoc ?? '';
        data.submitDate = data.submissionDateTime;
        this.fileAttachmentDetails = data.changeRequestAttachments;
        this.userName = data.updatedBy.name;
        if (data.submitDate != null) {
          this.showSubmitDate = true;
        }
        if (!this.isUserCanAccessRequest) {
          this.AcdForm.disable();
        }

        this.bindCRDetails(data);
        // this.getAttachmentListByCrNo();
      }
    });
  }

  setDropDownData(data: any) {
    if (data.requestPriorities) {
      this.priorityList = data.requestPriorities;
      this.priorityListDD = this.priorityList.map((x: any) => {
        return { id: x.id, originalLabel: x.label, label: x.label + ' (' + x.numberofdays + ')' }
      });
    }
    if (data.onBehalfOfUsers) {
      this.userList = data.onBehalfOfUsers;
    }
    if (data.facilities) {
      this.getFacilityList(data.facilities);
    }
    if (data.facilitiesList) {
      this.getFacilityList(data.facilitiesList);
    }
  }

  newACDRequestData(isSubmit: boolean = false) {
    console.log('newACDRequestData called', isSubmit ? this.statusType['submit'] : this.statusType['draft']);
    let submitACDData = new FormDataModel();
    submitACDData.Createdby = sessionStorage.getItem('userId');
    //submitACDData.changerequeststatusid = isSubmit ? 2 : 8;   
    submitACDData.changerequeststatusid = isSubmit ? this.statusType['submit'] : this.statusType['draft'];
    submitACDData.onBehalfOf = this.AssignUserId;
    submitACDData.domainid = 2;
    submitACDData.Description = this.AcdForm?.controls['description'].value;
    submitACDData.Justification = this.AcdForm?.controls['justification'].value;
    submitACDData.Ferrmoc = this.AcdForm?.controls['ferrMoc'].value;
    //submitACDData.Mocduedate = this.AcdForm?.controls['mocDueDate'].value;
    // Format the date to remove timezone information
    // Format the date as string directly to avoid timezone conversion
    const mocDueDate = this.AcdForm?.controls['mocDueDate'].value;
    if (mocDueDate) {
      const year = mocDueDate.getFullYear();
      const month = String(mocDueDate.getMonth() + 1).padStart(2, '0');
      const day = String(mocDueDate.getDate()).padStart(2, '0');
      submitACDData.Mocduedate = `${year}-${month}-${day}`;  // String instead of Date
    } else {
      submitACDData.Mocduedate = null;
    }
    submitACDData.Facilityid = this.AcdForm?.controls['facilityId'].value;
    submitACDData.Requestpriorityid = isNaN(this.AcdForm?.controls['priority'].value) ? this.setPriorityId(this.AcdForm?.controls['priority'].value) : this.AcdForm?.controls['priority'].value;
    submitACDData.fileAttachments = [...this.fileAttachmentDetails, ...this.deletedFileList];
    return submitACDData;
  }

  setPriorityId(priority: any) {
    if (this.crNo > 0) {
      if (!this.crDetails.requestPriority) {
        let priorityId = this.priorityList.find((x: any) => x.label.toLocaleLowerCase().includes(priority.toLocaleLowerCase()))?.id ?? 0;
        return priorityId;
      }
      return this.crDetails.requestPriority?.id;
    } else {
      let priorityId = this.priorityList.find((x: any) => x.label.toLocaleLowerCase().includes(priority.toLocaleLowerCase()))?.id ?? 0;
      return priorityId;
    }
  }

  intializeAcdFormData() {
    this.AcdForm = new FormGroup({
      onBehalfOf: new FormControl(),
      requestor: new FormControl(),
      description: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      justification: new FormControl('', Validators.maxLength(1000)),
      facilityId: new FormControl(0, [Validators.required, Validators.min(1)]),
      priority: new FormControl('', [Validators.required, Validators.min(1)]),
      mocDueDate: new FormControl(),
      ferrMoc: new FormControl(''),
      createdDate: new FormControl(''),
      dueDate: new FormControl(''),
      id: new FormControl(),
      status: new FormControl(),
      assignedto: new FormControl(),
      submitDate: new FormControl(),
      attachments: new FormControl(),
      facilityList: new FormControl()
    });
  }

  saveRequest(isSubmit: boolean = false) {
    this.isFormClicked = true;
    this.AcdForm.markAllAsTouched();
    if (this.AcdForm.valid) {
      this.postSubmitData(isSubmit);
    } else {
      this.commonservice.showNotificationMessage(
        'Please review the form fields.',
        'error',
        'center'
      );
    }
  }


  getFacilityList(data: any) {
    this.facilityListDD = data.sort((a: any, b: any) =>
      a.order > b.order ? 1 : -1
    );
  }

  getUser_FacilityList() {

    let requests = [this.acdservice.onBehalfOfUsers(),
    this.acdservice.getFacilityList()
    ];

    forkJoin(requests).subscribe({
      next: (response: any) => {
        if (response.length == requests.length) {
          if (response[0]) {
            let data = response[0] as any;
            this.userList = data;
          }

          if (requests[1]) {
            this.getFacilityList(response[1]);
          }
        }

        if (this.crNo > 0) {
          this.getACDDetailById();
        } else {
          this.isUserCanAccessRequest = true;
        }
      },
      error: (error: any) => {
        if (this.crNo > 0) {
          this.getACDDetailById();
        }
        else {
          this.isUserCanAccessRequest = true;
        }
      },
    });
  }

  crStatus: string = '';
  crDetails: any = null;

  getACDDetailById() {
    this.acdservice.viewAcd(this.crNo).subscribe((data) => {
      if (data) {
        this.crDetails = JSON.parse(JSON.stringify(data));
        this.isUserCanAccessRequest = data.isUserCanAccessRequest;
        if (data.submitDate != null) {
          this.showSubmitDate = true;
        }
        if (!this.isUserCanAccessRequest) {
          this.AcdForm.disable();
        }

        this.bindCRDetails(data);
        this.getAttachmentListByCrNo();
      }
    });
  }

  bindCRDetails(data: any) {
    this.crStatus = data.status;
    if (this.crStatus == 'Build' && this.crNo > 0) {
      this.showPriorityValue = true;
      data.priority = this.priorityListDD.find((x: any) => x.originalLabel == data.priority)?.id;
    } else if (this.crNo < 0 || this.crStatus != 'Build') {
      this.showPriorityValue = false
    }
    let facilityId = this.facilityListDD.find((x: any) => x.label == data.facility)?.id ?? 0;
    data.facilityId = facilityId;
    // this.userName = data.onBehalfOf ?? '';
    // if (data.mocDueDate && data.mocDueDate.split('-').length == 3) {
    //   let [day, month, year] = data.mocDueDate.split('-').map(Number);
    //   data.mocDueDate = new Date(year, month - 1, day);
    // }
    if (data.mocDueDate != null) {
      data.mocDueDate = new Date(data.mocDueDate);;
    }

    this.onUserValueChange(data.onBehalfOf ?? '');
    this.AcdForm.patchValue(data);
  }

  getAttachmentListByCrNo() {
    this.acdservice.ViewAcdAttachmentList(this.crNo).subscribe((data: any) => {
      this.fileAttachmentDetails = data;
    })
  }

  onUserValueChange(value: string) {
    this.selectedUser = value;
    this.userList.map((data: any) => {
      if (data.name === this.selectedUser) {
        this.AssignUserId = data.id;
      }
    });

  }

  postSubmitData(isSubmit: boolean = false) {
    let reqData = this.newACDRequestData(isSubmit);
    let dataToSend = JSON.stringify(reqData);

    let request: any = this.crNo <= 0 ? this.acdservice.submitAcd(dataToSend) : this.acdservice.UpdateCR(dataToSend, this.crNo);

    request.subscribe((data: any) => {
      if (data) {
        let notificationMsg = isSubmit ? `Change request ${this.crNo == 0 ? data : this.crNo} successfully submitted.` : `Created CR ${this.crNo == 0 ? data : this.crNo} successfully`;
        this.commonservice.showNotificationMessage(notificationMsg, 'success', 'center', 200, false);
        let navigateURL = isSubmit ? '/dashboard' : `ACD/EditRequest?CR=${this.crNo == 0 ? data : this.crNo}&buildType=MWO&step=Search`;
        this.router.navigateByUrl(navigateURL);
      }
    });
  }

  Clear() {
    if (this.crNo == 0) {
      this.AcdForm.reset();
      this.selectedFacilityItem = [];
      this.selectedPriorityItem = [];
      if (this.fileAttachmentDetails.length > 0) {
        let requestList = this.fileAttachmentDetails.map((file: AttachmentDetails) => this.attachmentservice.deleteAttachment(file.fileName ?? ''));
        forkJoin(requestList).subscribe((x: any) => {
          this.fileAttachmentDetails = [];
        });
      }
    } else {
      if (this.crDetails != null) {
        let deleteFIleList = this.fileAttachmentDetails.filter((file: AttachmentDetails) => !file.id);
        if (deleteFIleList) {
          deleteFIleList.forEach((file: AttachmentDetails) => {
            this.deleteFileAttachment(file);
          });
        }
        //this.bindCRDetails(JSON.parse(JSON.stringify(this.crDetails)));
        this.getACDDetailById();
      }
    }
  }

  saveAttachment(event: any) {
    let isNotDuplicateFile = true;
    let newFileName = this.getFileNameWithoutExtension(event.fileName);
    this.fileAttachmentDetails.forEach((file: any) => {
      if (this.getFileNameWithoutExtension(file?.fileName) == newFileName) {
        isNotDuplicateFile = false;
      }
    });

    if (isNotDuplicateFile) {
      this.fileAttachmentDetails.push(event);
    }
  }

  getFileNameWithoutExtension(fileName: string): string {
    if (!fileName) return '';

    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex > -1 ? fileName.substring(0, lastDotIndex) : fileName;
  }

  deletedFileList = new Array<AttachmentDetails>();

  deleteFileAttachment(file: AttachmentDetails) {
    const deletedFileIndex =
      this.fileAttachmentDetails.findIndex(item =>
        item.fileName === file.fileName
      )
    this.fileAttachmentDetails[deletedFileIndex].operation = 3;
    this.deletedFileList.push(this.fileAttachmentDetails[deletedFileIndex]);
    this.fileAttachmentDetails.splice(deletedFileIndex, 1);
    // this.attachmentservice.deleteAttachment(file.fileName ?? '').subscribe({
    //   next: () => {
    //     this.removedAttachmentHandling(file);
    //     this.fileAttachmentDetails.splice(deletedFileIndex, 1);
    //   },
    //   error: () => {
    //     this.commonservice.showNotificationMessage(`Error occuered`, 'error', 'center');
    //   }
    // })
  }

  removedAttachmentHandling(file: AttachmentDetails) {
    let attachmentTypeId = 0;
    let fileName = file.fileName ?? '';

    attachmentTypeId = 26;

    if (file.operation == 1) {
      this.fileAttachmentDetails = this.fileAttachmentDetails.filter((x: AttachmentDetails) => (x.attachmentTypeId !== attachmentTypeId || (x.attachmentTypeId == attachmentTypeId && x.fileName !== fileName)));
    }
    else if (file.operation == 2) {
      this.fileAttachmentDetails.filter((x: AttachmentDetails) => x.id == file.id).forEach((x: any) => {
        x.operation = 3;
      });
    }
  }

  onDoubleClick(autoComplete: AutoCompleteComponent) {
    autoComplete.toggle(true);
  }

  formatFileSize(bytes: number): string {
    const KB = 1024;
    const MB = KB * 1024;

    if (bytes < KB) {
      // Show raw bytes
      return `${bytes} B`;
    } else if (bytes < MB) {
      // Show KB with up to 2 decimals
      const sizeInKB = bytes / KB;
      return `${sizeInKB.toFixed(2)} KB`;
    } else {
      const sizeInMB = bytes / MB;
      return `${sizeInMB.toFixed(2)} MB`;
    }
  }
}
